module.exports = __webpack_public_path__ + "img/LUCKY_LIONS_04.24388503.jpg";